<template>
  <div>
    <img class="error-img" src="../assets/404.png" alt="">
    <a href="javascript:;" class="btn" @click="$router.go(-1)">返回上一页</a>
  </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>

<style lang="less" scoped>
.error-img {
  display: block;
  width: 4rem;
  margin: 3rem auto 0;
}
.btn {
  display: block;
  text-align: center;
  font-size: .26rem;
  line-height: .78rem;
}
</style>
